import { IHelpChapter } from '../../../api/fetchers/help/fetcher';
import { useHelpSlice } from '../../../store/slices/help/selectors';

// This hook gets content from help file based on chapter name key.
// Useful for building game-specific chapter pages for Help modal component.
export const getHelpChapterTranslations = (chapterKey: string): IHelpChapter | null => {
  const helpFile = useHelpSlice.getHelpFile();

  if (!helpFile) {
    return null;
  }

  const chapterContent = helpFile[chapterKey];

  if (!chapterContent) {
    return null;
  }

  return chapterContent;
};
